import React from 'react';
import '../assets/css/missionValues.css';

const MissionValues = () => {
    return (
        <section className="mission-section">
            <div className="mission-header">
                <h2 className="mission-title">Our Mission & Values</h2>
                <p className="mission-description">
                    Our mission is to provide world-class resin solutions that offer manufacturers exceptional strength, 
                    durability, and consistency in their end products. We believe in innovation, transparency, and long-term 
                    partnerships. We are committed to sustainability, operational excellence, strict quality testing, and 
                    responsible production practices to ensure uncompromised performance.
                </p>
            </div>

            <div className="why-cards" style={{ padding: '0' }}>
                <div className="why-card">
                    <div className="why-icon">
                        <img src={require('../assets/images/why-sec/factory.png')} alt="" />
                    </div>
                    <h4>Custom Resin Formulations</h4>
                    <p>
                        We manufacture UF, MF, MUF, PF & Binder resins tailored to plywood,
                        adhesive, molding, and fish-feed applications.
                    </p>
                </div>

                <div className="why-card">
                    <div className="why-icon">
                        <img src={require('../assets/images/why-sec/manufacturing.png')} alt="" />
                    </div>
                    <h4>Modern Manufacturing Facility</h4>
                    <p>
                        We are situated in Sarigam, Dist. Valsad, Gujarat, India.
                    </p>
                </div>

                {/* <div className="why-card">
                    <div className="why-icon">
                        <img src={require('../assets/images/why-sec/verified.png')} alt="" />
                    </div>
                    <h4>100% Quality Assurance</h4>
                    <p>
                        Every batch undergoes strict testing to ensure strength, bonding
                        performance, and consistency.
                    </p>
                </div> */}

                <div className="why-card">
                    <div className="why-icon">
                        <img src={require('../assets/images/why-sec/location.png')} alt="" />
                    </div>
                    <h4>On-Time Pan-India Delivery</h4>
                    <p>
                        We supply resins across India with reliable logistics and
                        responsive support.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default MissionValues;